import { ICustomMilestone } from '@/types';
import moment from 'moment-timezone';
import { IMilestone, PaymentType } from '../context';

const getPaymentType = (paymentDate: moment.Moment, isMultiple: boolean): PaymentType => {
  if (!isMultiple) {
    return PaymentType.ONETIME;
  }
  const today = moment().utc().startOf('day');
  return moment(paymentDate).utc().startOf('day').isSame(today)
    ? PaymentType.INITIAL
    : PaymentType.COMMITTED;
};

export const prepareFinalCustomMilestones = (milestones: ICustomMilestone[]): IMilestone[] => {
  const sortedMilestones = milestones.sort(
    (a, b) =>
      moment(a.paymentDate).utc().toDate().getTime() -
      moment(b.paymentDate).utc().toDate().getTime()
  );

  const finalMilestones: IMilestone[] = sortedMilestones.map((milestone, idx: number) => {
    const { paymentDate, amount } = milestone;
    const startPeriod = moment(paymentDate).utc().toDate();

    const nextMilestone = sortedMilestones[idx + 1];
    const endPeriod = nextMilestone
      ? moment(nextMilestone.paymentDate).utc().toDate()
      : startPeriod;

    const type = getPaymentType(paymentDate, sortedMilestones.length > 1);

    return {
      paymentDate: moment(paymentDate).utc(),
      milestonePeriod: idx + 1,
      payments: [],
      type,
      totalDiscount: 0,
      subtotal: amount,
      total: amount,
      startPeriod,
      endPeriod,
    };
  });

  return finalMilestones;
};
